<div class="layout-content" id="scheduleDialog">
	<form (ngSubmit)="submit()" [formGroup]="scheduleForm">
		<div class="grid mb-6">
			<div [ngClass]="col12Responsive() + getSpaceBottomErrorMessage(this.f.name)">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.name, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.name, 'label')">{{ 'NAME' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.name, 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="schedule-add-input-name"
							formControlName="name" autocomplete="schedule-name" placeholder="{{ 'NAME' | translate }}" />
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.name)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div [ngClass]="col12Responsive()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.scenery, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.scenery, 'label')">{{ 'SCENARIO' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.scenery, 'borderInput')">
						<p-dropdown [options]="sceneries" [ngClass]="dynamicInputTextWidth()"
							styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5" id="schedule-input-scenery"
							placeholder=" {{'SCENARIO' | translate }}" formControlName="scenery" dataKey="Id">
							<ng-template pTemplate="selectedItem">
								<div class="item" class="flex align-items-center justify-content-center">
									<div class="flex justify-content-center">{{ (f.scenery) ? f.scenery.value.Name : "" }}</div>
								</div>
							</ng-template>
							<ng-template let-scenery pTemplate="item">
								<div class="item flex align-items-center justify-content-center">
									<div>{{scenery.Name}}</div>
								</div>
							</ng-template>
						</p-dropdown>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.scenery)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
		</div>

		<p-stepper [(activeStep)]="activeIndex">
			<!-- SCHEDULE -->
			<p-stepperPanel>
				<ng-template pTemplate="header">
					<button pButton pRipple type="button" class="bg-transparent h-3rem" (click)="changeActiveTabClick(0)"
						[class]="getColorFirstTab()">
						<div class="flex flex-row align-items-center justify-content-center">
							<i class="pi cm-date-time text-2xl pr-2"></i>
							<label *ngIf="!onExtendedMobile()" class="font-medium text-lg">{{ 'SCHEDULE' | translate }}</label>
						</div>
					</button>
				</ng-template>
				<ng-template pTemplate="content">
					<div class="grid">
						<div [ngClass]="col12Responsive()">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.startDate, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.startDate, 'label')">{{ 'START_DATE' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.startDate, 'borderInput')">
									<p-calendar [showIcon]="true" inputId="icon" formControlName="startDate" appendTo="body"
										placeholder="dd/mm/yyyy" [minDate]="minDate" [defaultDate]="today" dateFormat="dd/mm/yy"
										[ngClass]="dynamicInputTextWidth()" [styleClass]="dynamicInputTextWidth()"
										inputStyleClass="pl-6 sm:pl-5 border-noround-right">
									</p-calendar>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.startDate)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' |
								translate }}</small>
						</div>
						<div [ngClass]="col12Responsive()">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.endDate, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.endDate, 'label')">{{ 'END_DATE' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.endDate, 'borderInput')">
									<p-calendar [showIcon]="true" inputId="icon" formControlName="endDate" appendTo="body"
										placeholder="dd/mm/yyyy" [minDate]="scheduleForm.value.startDate" [defaultDate]="today"
										dateFormat="dd/mm/yy" [ngClass]="dynamicInputTextWidth()"
										[styleClass]="dynamicInputTextWidth()"
										inputStyleClass="pl-6 sm:pl-5 border-noround-right">
									</p-calendar>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.endDate)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' |
								translate }}</small>
						</div>
						<div [ngClass]="col12Responsive() + getSpaceBottomErrorMessage(this.f.startTime)">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.startTime,'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.startTime,'label')">{{ 'START_TIME' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.startTime,'borderInput')">
									<p-calendar [showIcon]="true" inputId="icon" formControlName="startTime" appendTo="body"
										timeOnly="true" [ngClass]="dynamicInputTextWidth()" [styleClass]="dynamicInputTextWidth()"
										inputStyleClass="pl-6 sm:pl-5 border-noround-right">
									</p-calendar>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.startTime)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' |
								translate }}</small>
						</div>
						<div [ngClass]="col12Responsive() + getSpaceBottomErrorMessage(this.f.timezone)">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.timezone, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.timezone, 'label')">{{ 'TIMEZONE' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.timezone, 'borderInput')">
									<p-autoComplete formControlName="timezone" [suggestions]="filteredTimezone"
										[ngClass]="dynamicInputTextWidth()" [styleClass]="dynamicInputTextWidth()"
										inputStyleClass="pl-6 sm:pl-5 border-noround-right" id="schedule-input-timezone"
										(completeMethod)="filterTimezone($event)" [dropdown]="true" [forceSelection]="true">
									</p-autoComplete>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.timezone)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' |
								translate }}</small>
						</div>
						<div class="col-12" [class]="customPaddingX()">
							<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
								[ngClass]="manageRespStyle('borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="manageRespStyle('label')">{{ 'COLOR_SCHEDULE' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="manageRespStyle('borderInput')">
									<div *ngFor="let color of listColor"
										class="w-2rem h-2rem flex-shrink-0 border-circle cursor-pointer surface-border opacity-60 transition-all transition-duration-300 ml-2 mt-2"
										[ngStyle]="{'color': color, 'background-color': color}" (click)="setColorSchedule(color)"
										[style.box-shadow]="getColorSchedule(color) ? '0 0 0 0.3rem' : null"
										[style.border]="getColorSchedule(color) ? '1px solid white' : '' ">
										<i *ngIf="getColorSchedule(color)" class="pi cm-check text-3xl text-900"></i>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="flex py-3 justify-content-end">
						<!-- [disabled]="!canSwitchTab()" -->
						<p-button label="{{ 'NEXT' | translate }}" icon="pi cm-arrow-right" iconPos="right" severity="primary"
							(onClick)="changeActiveTabClick(1)" />
					</div>
				</ng-template>
			</p-stepperPanel>

			<!-- REPEAT -->
			<p-stepperPanel>
				<ng-template pTemplate="header">
					<button pButton pRipple type="button" class="bg-transparent h-3rem" (click)="changeActiveTabClick(1)"
						[class]="getColorSecondTab()">
						<div class="flex flex-row align-items-center justify-content-center">
							<i class="pi cm-schedule-repeat text-2xl pr-2"></i>
							<label *ngIf="!onExtendedMobile()" class="font-medium text-lg">{{ 'REPEAT' | translate }}</label>
						</div>
					</button>
				</ng-template>

				<ng-template pTemplate="content" let-prevCallback="prevCallback" let-nextCallback="nextCallback">
					<div class="grid">
						<div class="col-12" [ngClass]="customPaddingX()"
							[class]="(this.screenWidth > MAX_MD_WIDTH) && (this.schedule.EveryKey === 'not_repeating') ? 'pb-8 mb-7' : ''">
							<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
								[ngClass]="manageRespStyle('borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="manageRespStyle('label')">{{ 'REPEAT_TYPE' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="manageRespStyle('borderInput')">
									<div *ngFor="let repeat of repetitions; let i=index;"
										class="flex align-items-center justify-content-center ml-3 mt-2 md:mb-0">
										<p-radioButton [value]="repeat.Value" formControlName="everyKey" [id]="repeat.Value"
											class="p-radiobutton-policy mr-2"
											(onFocus)="checkEveryKey(repeat.Value)"></p-radioButton>
										<p-tag [value]="repeat.Name | translate" styleClass="p-tag-info"></p-tag>
									</div>
								</div>
							</div>
						</div>
						<div class="col-12" [ngClass]="customPaddingX()" *ngIf="this.schedule.EveryKey !== 'not_repeating'"
							[class]="(this.screenWidth > MAX_MD_WIDTH) && (this.schedule.EveryKey === 'days') ? 'pb-8' : ''">
							<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
								[ngClass]="newShowErrors(this.f.everyValue, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.everyValue, 'label')">{{ 'FREQUENCY' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.everyValue, 'borderInput')">
									<p-inputNumber formControlName="everyValue" inputId="everyValue-buttons" step="1"
										[useGrouping]="false" [maxFractionDigits]="0" [showButtons]="true" [min]="1"
										incrementButtonClass="p-0" decrementButtonClass="p-0 border-noround"
										inputStyleClass="border-noround-right pl-6" [ngClass]="dynamicInputTextWidth()"
										[styleClass]="dynamicInputTextWidth()">
									</p-inputNumber>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.everyValue)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' |
								translate }}</small>
						</div>
						<div class="col-12" [ngClass]="customPaddingX()"
							[class]="(this.screenWidth > MAX_MD_WIDTH) ? 'pb-4' : ''">
							<ng-container formArrayName="weekDays" *ngIf="this.schedule.EveryKey === 'weeks'">
								<div class="flex justify-content-between flex-wrap"
									[ngClass]="manageRespStylewithError(this.f.weekDays, 'borderRow')">
									<div class="flex align-items-center justify-content-center"
										[ngClass]="manageRespStylewithError(this.f.weekDays, 'label')">{{ 'WEEK_DAYS' | translate
										}}</div>
									<div class="flex align-items-center justify-content-center"
										[ngClass]="manageRespStylewithError(this.f.weekDays, 'borderInput')">
										<p-checkbox *ngFor="let day of daysOfWeek;" [formControlName]="day.Value" [binary]="true"
											label="{{ day.Name | translate }}" class="ml-4 mt-2"
											[class]="showErrorRequiredCheckBox(this.f.weekDays)">
										</p-checkbox>
									</div>
								</div>
								<small *ngIf="showErrorRequiredMessage(this.f.weekDays)"
									class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{
									'WEEK_DAYS_REQUIRE' | translate }}</small>
							</ng-container>
						</div>
						<div class="col-12" [ngClass]="customPaddingX()" *ngIf="this.schedule.EveryKey === 'months'">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.monthDay, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.monthDay, 'label')">{{ 'DAY_OF_MONTH' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.monthDay, 'borderInput')">
									<p-inputNumber formControlName="monthDay" inputId="monthDay-buttons" step="1"
										[useGrouping]="false" [maxFractionDigits]="0" [showButtons]="true" [min]="1" [max]="31"
										incrementButtonClass="p-0" decrementButtonClass="p-0 border-noround"
										inputStyleClass="border-noround-right" [ngClass]="dynamicInputTextWidth()"
										[styleClass]="dynamicInputTextWidth()">
									</p-inputNumber>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.monthDay)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' |
								translate }}</small>
						</div>
					</div>

					<div class="flex py-3 justify-content-between">
						<p-button label="{{ 'BACK' | translate }}" icon="pi cm-arrow-left" iconPos="left" severity="secondary"
							(onClick)="changeActiveTabClick(0)" />
						<p-button label="{{ 'NEXT' | translate }}" icon="pi cm-arrow-right" iconPos="right" severity="primary"
							(onClick)="changeActiveTabClick(2)" />
					</div>
				</ng-template>
			</p-stepperPanel>

			<!-- EXCLUDE -->
			<p-stepperPanel>
				<ng-template pTemplate="header">
					<button pButton pRipple type="button" class="bg-transparent h-3rem" (click)="changeActiveTabClick(2)"
						[class]="getColorThirdTab()">
						<div class="flex flex-row align-items-center justify-content-center">
							<i class="pi cm-schedule-exclusion text-2xl pr-2"></i>
							<label *ngIf="!onExtendedMobile()" class="font-medium text-lg">{{ 'EXCLUDE' | translate }}</label>
						</div>
					</button>
				</ng-template>

				<ng-template pTemplate="content" let-prevCallback="prevCallback" let-nextCallback="nextCallback">
					<div class="grid">
						<div class="col-12" [ngClass]="customPaddingX()"
							[class]="(this.screenWidth > MAX_MD_WIDTH) && (!f.calendar.value || f.calendar.value.Id === -1) ? 'pb-7 mb-8' : ''">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.calendar, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.calendar, 'label')">{{ 'EXCLUSIONS_CALENDAR' | translate }}
								</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.calendar, 'borderInput')">
									<p-dropdown [options]="calendars" formControlName="calendar"
										[ngClass]="dynamicInputTextWidth()" styleClass="{{ dynamicInputTextWidth() }} pl-5"
										inputStyleClass="text-center" placeholder="{{ 'EXCLUSIONS_CALENDAR' | translate }}"
										dataKey="Id" optionLabel="Name" (onChange)="onSelectCalendars()" appendTo="body">
									</p-dropdown>
								</div>
							</div>
						</div>
						<div *ngIf="getCalendar()" class="col-12" [ngClass]="customPaddingX()">
							<h5>{{ 'EXCLUDED_DAYS' | translate }}</h5>
							<app-exceptions-calendar-card [calendarId]="f.calendar.value.Id"
								[edit]="false"></app-exceptions-calendar-card>
						</div>
					</div>

					<div class="flex py-3 justify-content-start">
						<p-button label="{{ 'BACK' | translate }}" icon="pi cm-arrow-left" severity="secondary"
							(onClick)="changeActiveTabClick(1)" />
					</div>
				</ng-template>
			</p-stepperPanel>

			<ng-template pTemplate="end">
				<div class="grid mt-2 mb-1 mx-1 flex justify-content-center align-items-center">
					<button *ngIf="enableConfirmButtons()" type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
						class="p-button-primary text-xl font-normal mx-1 mb-2" [ngClass]="dynamicButtonWidth()">
					</button>
					<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CLOSE' | translate }}"
						class="p-button-secondary text-xl font-normal mx-1 mb-2" [ngClass]="dynamicButtonWidth()">
					</button>
				</div>
			</ng-template>
		</p-stepper>
	</form>
</div>